import { BASE_URL } from "../../constant";

const getAllStats = async () => {
    const response = await fetch(`${BASE_URL.VALIDATOR_API}/explorer/dashboard`)
    const result = await response.json();
    return result;
}

export default getAllStats;
